import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CellTemplateServices {

    constructor(private sanitizer: DomSanitizer) { }

    renderCell(cellHtml) {
        const sanitizeHTML = html => this.sanitizer.sanitize(SecurityContext.HTML, html);
    
        if (cellHtml.indexOf('<') > -1 && cellHtml.indexOf('>') > -1) {
          return `<div class="cell-data"><span class="cell-content">${cellHtml}</span></div>`
        }
        else {
          return `<div class="cell-data"><span class="cell-content">${sanitizeHTML(cellHtml)}</span></div>`
        }
    }
}
